import { css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'

const dividerCss = css`
  min-height: 1px;
  background-color: var(${DesignToken.BorderBasicSecondary});
  margin-block: var(${SpacingToken.Spacing4});
  width: 100%;
`

interface Props {
  className?: string
}

export const Divider = ({ className }: Props) => (
  <div css={dividerCss} className={className} />
)
